import { render, staticRenderFns } from "./curriculumOrder.vue?vue&type=template&id=7c021950"
import script from "./curriculumOrder.vue?vue&type=script&lang=js"
export * from "./curriculumOrder.vue?vue&type=script&lang=js"
import style0 from "./curriculumOrder.vue?vue&type=style&index=0&id=7c021950&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports